import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7h6","key":"svg-0"}],["path",{"d":"M7 4v6","key":"svg-1"}],["path",{"d":"M20 18h-6","key":"svg-2"}],["path",{"d":"M5 19l14 -14","key":"svg-3"}]]

/**
 * IconPlusMinus
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItcGx1cy1taW51cyIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNCA3aDYiIC8+CiAgPHBhdGggZD0iTTcgNHY2IiAvPgogIDxwYXRoIGQ9Ik0yMCAxOGgtNiIgLz4KICA8cGF0aCBkPSJNNSAxOWwxNCAtMTQiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/plus-minus
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconPlusMinus = createReactComponent('outline', 'plus-minus', 'PlusMinus', __iconNode);

export default IconPlusMinus;